/**
 * Inline info icon that opens Help Center to a specific article.
 */

import React from 'react';
import { Info } from 'lucide-react';
import { useOptionalHelpCenter } from './HelpCenterContext';

export interface HelpArticleIconProps {
  articleId: string;
  /** Accessible label / tooltip text */
  label?: string;
  className?: string;
}

export function HelpArticleIcon({
  articleId,
  label = 'Open help article',
  className = '',
}: HelpArticleIconProps) {
  const helpCenter = useOptionalHelpCenter();

  if (!helpCenter) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        helpCenter.openHelpCenter(articleId);
      }}
      className={`inline-flex items-center justify-center rounded-full p-0.5 text-theme-text-disabled hover:text-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-1 transition-colors ${className}`}
      aria-label={label}
      title={label}
    >
      <Info className="h-4 w-4" aria-hidden="true" />
    </button>
  );
}
